import { useState } from "react"
import {
    Container,
    Grid,
    AppBar,
    Tabs,
    Tab,
} from "@material-ui/core"
import AccountBalanceIcon from "@material-ui/icons/AccountBalance"
import FolderSharedIcon from '@material-ui/icons/FolderShared'
import NotificationsIcon from '@material-ui/icons/Notifications'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import Pagos from "./Pagos";
import Documentos from "./Documentos";
import Notificaciones from "./Notificaciones";
import Items from "./Items"
import { useLocation } from "react-router-dom"
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}

export default function TapCliente() {
    const [value, setValue] = useState(0);
    const location = useLocation()
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Container>
            <Grid item xs={12}>
                <AppBar position="static" color="secondary">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="on"
                        indicatorColor="primary"
                        aria-label="scrollable force tabs example"
                    >
                        <Tab
                            label="Pagos"
                            icon={<AccountBalanceIcon />}
                            {...a11yProps(0)}
                        />
                        <Tab
                            label="Documentos"
                            icon={<FolderSharedIcon />}
                            {...a11yProps(1)}
                        />
                        <Tab
                            label="Notificaciones"
                            icon={<NotificationsIcon />}
                            {...a11yProps(2)}
                        />
                        {
                            (!location.state?.reservas) &&
                            <Tab
                                label="Items"
                                icon={<ShoppingCartIcon />}
                                {...a11yProps(3)}
                            />
                        }

                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <Pagos />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Documentos />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Notificaciones />
                </TabPanel>
                {
                    (!location.state?.reservas) &&
                    <TabPanel value={value} index={3}>
                        <Items />
                    </TabPanel>
                }

            </Grid>
        </Container>
    );
}
